import LayoutVendingPageView from './layout-vending-page-view'

export default LayoutVendingPageView
